const initialState = {
    bulderElements: [],
    selectedElement: null
}

const templateBuilderReducer = (state = initialState, action) => {
    switch (action.type) {
        case "ADD_ELEMENT": {
            state.bulderElements.push(action.data);
            return { ...state };
        }
        case "UPDATE_ELEMENT": {
            state.bulderElements[action.data.index] = action.data.data;
            return { ...state };
        }
        case "UPDATE_ELEMENT_POSITION": {
            let findIndex = state.bulderElements.findIndex(x => x.id === action.data.id);
            if (findIndex > -1) {
                state.bulderElements[findIndex].x = action.data.x;
                state.bulderElements[findIndex].y = action.data.y;
            }
            return { ...state };
        }
        case "DELETE_ELEMENT": {
            let findIndex = state.bulderElements.findIndex(x => x.id === action.data.id);
            if (findIndex > -1) {
                state.bulderElements.splice(findIndex, 1);
            }
            return { ...state };
        }
        case "SET_CANVAS": {
            state.bulderElements = [...action.data];
            return { ...state };
        }
        case "CLEAR_CANVAS": {
            state.bulderElements = [];
            return { ...state };
        }
        case "SET_SELECTED_ELEMENT": {
            state.selectedElement = action.data.element;
            return { ...state };
        }
        default: {
            return { ...state };
        }
    }
}

export default templateBuilderReducer;